export default {"src":"/_next/static/image/public/edit.410bbb271957b2f1c0dc367f3491af51.svg","height":15,"width":15};